export class Event {
    constructor(
        public title: string,
        public startTime: string,
        public endTime: string,
        public location: string
    ){}
}

